<script>
import { useAlert } from 'dashboard/composables';

  export default {
    name: "EditLabelModal",
    props: {
      booking: {
        type: Object,
        required: true
      }
    },
    methods: {
      handleClose() {
        this.$emit('close');
      },
      async handleSubmit() {
        try{
          if (!this.newLabel) {
            useAlert('Please enter a label.');
            return;
          }
          this.isSubmitting = true;
          await this.$store.dispatch('rentalBranch/updateLabel', {
            booking_id: this.booking.booking_id,
            payload: { label: this.newLabel }
          });
          useAlert('Booking label updated successfully.');
          this.$emit('close');
          this.$emit('refresh');
        }catch(err){
          useAlert(err.message || 'Failed to update label.');
        }finally {
          this.isSubmitting = false;
        }
      }
    },
    data() {
      return {
        newLabel: '',
        isSubmitting: false,
      }
    },
    mounted() {
      this.newLabel = this.booking.label || '';
    }
  }
</script>

<template>
    <div class="z-50 fixed inset-0 flex items-center bg-slate-800/40 px-4">
      <div class="max-h-[80vh] overflow-y-auto mx-auto my-2 p-6 border-2 rounded-lg bg-white dark:bg-slate-800 shadow-xl min-w-[350px] w-full max-w-md relative">
        <button 
          @click="handleClose" 
          class="absolute top-2 right-2 text-slate-400 hover:text-slate-700 dark:hover:text-slate-200 text-xl"
          > &times; </button>
        <h2 
          class="text-xl font-semibold mb-4 text-slate-900 dark:text-slate-100"
          >Edit Booking Label</h2>

        <div class="mb-4">
          <label for="label">New label:</label>
          <input
            id="label"
            type="text"
            v-model="newLabel"
          />
        </div>

        <div class="flex justify-end mt-4">
          <button @click="handleSubmit" :disabled="isSubmitting" class="px-4 py-2 rounded bg-woot-500 text-white hover:bg-woot-600 disabled:opacity-60">
            {{ isSubmitting ? 'Submitting...' : 'Submit' }}
          </button>
        </div>
      </div>
    </div>
</template>